module.exports = __webpack_public_path__ + "static/media/citaat.b9dac323.svg";